import React from 'react';
import './slider-polysorbdesigner.css';
import Polysorbdesigner1 from '../../images/polysorb/banner5.webp';
import Polysorbdesigner2 from '../../images/polysorb/banner5.webp';
function slider() {
	return (
	  
	<>
	<div id="slider-polysorbdesigner">
		<div id="carouselExampleIndicators5" className="carousel slide" data-ride="carousel">
  			<ol className="carousel-indicators">
    			<li data-target="#carouselExampleIndicators5" data-slide-to="0" className="active"></li>
    			<li data-target="#carouselExampleIndicators5" data-slide-to="1"></li>
  			</ol>
  			<div className="carousel-inner">
    			<div className="carousel-item active">
      				<img className="d-block w-100" src={Polysorbdesigner1} alt="Polysorb Designer1" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>ACOUSTICAL DESIGNER PANELS</h1>
					</div>
				</div>
    			<div className="carousel-item">
      				<img className="d-block w-100" src={Polysorbdesigner2} alt="Polysorb Designer2" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>ACOUSTICAL DESIGNER PANELS</h1>
					</div>
				</div>
			</div>
  			<a className="carousel-control-prev" href="#carouselExampleIndicators5" role="button" data-slide="prev">
    			<span className="carousel-control-prev-icon" aria-hidden="true"></span>
    			<span className="sr-only">Previous</span>
  			</a>
  			<a className="carousel-control-next" href="#carouselExampleIndicators5" role="button" data-slide="next">
    			<span className="carousel-control-next-icon" aria-hidden="true"></span>
    			<span className="sr-only">Next</span>
  			</a>
		</div>
	</div>
	</>
);
}
export default slider;